import React from 'react';

interface Props {
  onReset: () => void,
  className?: string,
  label?: string,
  clearBulkSelected?: () => void,
  disabled: boolean,
}

const SimpleResetSearch: React.FC<Props> = ({
  onReset,
  clearBulkSelected,
  className,
  label,
  disabled,
}) => {
  return (
    <button
      className={className || 'btn btn-danger'}
      onClick={() => {
        onReset();
        if (clearBulkSelected) {
          clearBulkSelected();
        }
      }}
      disabled={disabled}
      type="button"
    >
      {label || 'Reset Search'}
    </button>
  );
};

export default SimpleResetSearch;
